import React from "react";

export default function MainFeatureLiquid({ imageSrc, reverse = false }) {
  return (
    <section className="section-liquid">
      <div className="container-liquid">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "60px",
            alignItems: "center",
          }}
        >
          {/* Content */}
          <div
            style={{
              order: reverse ? 2 : 1,
              textAlign: reverse ? "right" : "left",
            }}
          >
            <span className="subheading-liquid">
              {reverse ? "Get Started" : "Quality Work"}
            </span>
            <h2
              className="heading-liquid"
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                marginTop: "16px",
                marginBottom: "24px",
              }}
            >
              {reverse ? (
                <>
                  Seamless Onboarding in Three Simple{" "}
                  <span
                    style={{
                      background: "var(--gradient-secondary)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      color: "#AF52DE", // Fallback color
                    }}
                  >
                    Steps.
                  </span>
                </>
              ) : (
                <>
                  Professional{" "}
                  <span
                    style={{
                      background: "var(--gradient-primary)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      color: "#007AFF", // Fallback color
                    }}
                  >
                    Excellence
                  </span>
                </>
              )}
            </h2>
            <p
              className="text-liquid"
              style={{
                fontSize: "1.2rem",
                marginBottom: "32px",
                lineHeight: "1.7",
              }}
            >
              {reverse
                ? "Start your journey with us in just three simple steps. We make the process seamless and efficient."
                : "We deliver high-quality, professional solutions that exceed expectations and drive results for your business."}
            </p>

            {reverse && (
              <div style={{ marginBottom: "32px" }}>
                {["Connect", "Design", "Launch"].map((step, index) => (
                  <div
                    key={index}
                    className="glass-secondary"
                    style={{
                      padding: "16px 24px",
                      marginBottom: "16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "var(--gradient-primary)",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      {index + 1}
                    </div>
                    <span className="text-liquid" style={{ fontWeight: "500" }}>
                      {step}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <button className="glass-button glass-button-primary glow">
              Learn More
            </button>
          </div>

          {/* Image */}
          <div
            style={{
              order: reverse ? 1 : 2,
              textAlign: "center",
            }}
          >
            <div
              className="glass liquid-float"
              style={{
                padding: "20px",
                display: "inline-block",
              }}
            >
              <img
                src={imageSrc}
                alt={reverse ? "Get Started" : "Professional Work"}
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "auto",
                  borderRadius: "16px",
                  filter: "drop-shadow(0 10px 30px rgba(0, 0, 0, 0.3))",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
